import React from 'react';

import Box from '../../../elements/Box';
import Text from '../../../elements/Text';

import Separator from '../atoms/Separator';
import { StyledProps } from '@front10';

interface ComplexSchedule {
  open?: string;
  close?: string;
}

export type BusSchedule = ComplexSchedule | string;

interface Props {
  showDay?: boolean;
  showSchedules?: boolean;
  day?: string;
  schedules?: BusSchedule[];
  dayStyles?: StyledProps;
  scheduleStyles?: StyledProps;
}

function OperationDay({
  showDay = true,
  showSchedules = true,
  day = '',
  schedules = [],
  dayStyles = {},
  scheduleStyles = {},
  ...props
}: StyledProps<Props>) {
  return (
    <Box className="station-item-operation-day" display="flex" marginBottom="2" {...props}>
      {showDay && (
        <Box flex="1">
          <Text textTransform="capitalize" {...dayStyles}>
            {day}
          </Text>
        </Box>
      )}
      {showSchedules && (
        <Box flex="1">
          {schedules.map((item) => {
            const key = typeof item === 'string' ? item : `${item?.open}${item?.close}`;
            return (
              <Box key={key} display="flex" alignItems="center" {...scheduleStyles}>
                {typeof item === 'string' ? (
                  item
                ) : (
                  <>
                    {<Text>{item?.open}</Text>}
                    <Separator content="-" />
                    {<Text>{item?.close}</Text>}
                  </>
                )}
              </Box>
            );
          })}
        </Box>
      )}
    </Box>
  );
}

OperationDay.componentName = 'OperationDay';

export default OperationDay;
